import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import React from 'react';
import { useState } from 'react';
import DefaultInput1 from '../../../../package/1-input/index';
import { getFirestore } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';
import DefaultSelect1 from '../../../../package/1-select/index';
import DefaultTextarea1 from '../../../../package/1-textarea/index';
import DefaultCheckBox from '../../../../package/checkBox/index';
import ErrorMessage from '../../../../package/error/index';
import { benefitData, employmentData20, infoData, ValidationError } from '../../../../../type';
import DefaultSelect2 from 'src/salon/package/2-select';
import Hint from '../../../1.manual/3.school/2.edit/hint';
import DefaultDesc from 'src/salon/package/desc';

type EmploymentProps = {
  info: infoData;
  companyId: string;
  year: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  benefit: benefitData;
  setBenefit: React.Dispatch<React.SetStateAction<benefitData>>;
  employment20: employmentData20;
};

const SchoolEmployment: React.FC<EmploymentProps> = ({ info, companyId, year, setChangeData, benefit, setBenefit, employment20 }) => {

  const [ errorMessage, setErrorMessage ] = useState<ValidationError>(null);
  const [ banner, setBanner ] = useState<boolean>(false);
  const [ hintText, setHintText ] = useState<any>({ title: "", desc: "" });

  function validateData(data: benefitData): ValidationError {
    if (!data.commutingAllowance.exist) return { message: '通勤手当の有無を選択してください。', fieldId: 'commutingAllowance.exist' };
    if ((data.commutingAllowance.exist === "一定額" || data.commutingAllowance.exist === "実費支給（上限有り）") && !data.commutingAllowance.text) return { message: '通勤手当の金額を入力してください。', fieldId: 'commutingAllowance.text' };
    if (data.overtime.exist == null) return { message: '時間外労働の有無を選択してください。', fieldId: 'overtime' };
    if (data.overtime.exist && !data.overtime.text) return { message: '時間外労働の月平均を入力してください。', fieldId: 'overtime.text' };
    if (data.overtime.exist && data.overtime.text && !/^[0-9]+$/.test(data.overtime.text)) return { message: '時間外労働の月平均を半角数字で入力してください。', fieldId: 'overtime.text' };
    if (!data.workingHours.time1Start) return { message: '勤務時間 ①の開始時間を選択してください。', fieldId: 'workingHours.time1Start' };
    if (!data.workingHours.time1End) return { message: '勤務時f間 ①終了時間を選択してください。', fieldId: 'workingHours.time1End' };
    if (data.workingHours.time2Start === "" && data.workingHours.time2End !== "") return { message: '勤務時間 ②の開始時間を選択してください。', fieldId: 'workingHours.time2Start' };
    if (data.workingHours.time2Start !== "" && data.workingHours.time2End === "") return { message: '勤務時間 ②の終了時間を選択してください。', fieldId: 'workingHours.time2Start' };
    if (data.workingHours.time3Start === "" && data.workingHours.time3End !== "") return { message: '勤務時間 ③の開始時間を選択してください。', fieldId: 'workingHours.time3Start' };
    if (data.workingHours.time3Start !== "" && data.workingHours.time3End === "") return { message: '勤務時間 ③の終了時間を選択してください。', fieldId: 'workingHours.time3Start' };
    if (!data.dailyBreak) return { message: '休憩時間（分）を入力してください。', fieldId: 'dailyBreak' };
    if (data.dailyBreak && !(/^\d+$/.test(data.dailyBreak))) return { message: '休憩時間（分）を半角数字で入力してください。', fieldId: 'dailyBreak' };
    if (data.regularHolidays.length === 0) return { message: '定休日を選択してください。', fieldId: 'regularHolidays' };
    if (!data.holidayPolicy.exist) return { message: '休日制度を入力してください。', fieldId: 'holidayPolicy.exist' };
    if (data.holidayPolicy.exist === "その他" && !data.holidayPolicy.text) return { message: '休日制度を入力してください。', fieldId: 'holidayPolicy.text' };
    if (!data.annualHolidays) return { message: '年間休日数を入力してください。', fieldId: 'annualHolidays' };
    if (data.annualHolidays && isNumeric(data.annualHolidays)) return { message: '年間休日数を数値で入力してください。', fieldId: 'annualHolidays' };
    if (!data.paidLeave) return { message: '年次有給休暇数(日)を入力してください。', fieldId: 'paidLeave' };
    if (isNumeric(data.paidLeave)) return { message: '年次有給休暇数(日)を数値で入力してください。', fieldId: 'paidLeave' };
    if (data.tabaco.length === 0) return { message: '受動喫煙対策を入力してください。', fieldId: 'tabaco' };
    return null;
  }

  function check() {
    setErrorMessage(null);
    window.scrollTo(0, 0);
    const error = validateData(benefit);
    if (error) {
      setErrorMessage(error);

      const el = document.getElementById(error.fieldId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }

      return;
    }
    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  const save = async (isCompleted: boolean) => {
    try {
      setUploading(true);

      const db = getFirestore();

      const payload = {
        ...benefit,
        isCompleted,
        time: new Date(),
      };

      const breakTimeWarning = (() => {
        if (Boolean(info.exist36Agreement)) return false;
        const s = parseTimeToMinutes(benefit.workingHours.time1Start);
        const e = parseTimeToMinutes(benefit.workingHours.time1End);
        if (s === null || e === null) return false;
        return ((e - s) - Number(benefit.dailyBreak)) > 480;
      })();

      const benefitWarnings = {
        agreement36: !Boolean(info.exist36Agreement) && Boolean(benefit.overtime.exist),
        overtime45: 45 < (Number(benefit.overtime.text) + Number(employment20?.fixedOvertime?.time || 0)),
        breakTime: breakTimeWarning,
        paidLeave10: 10 > Number(benefit.paidLeave),
      };

      await writeJobPostingBothStores(db, companyId, year, {
        benefit: payload,
        "warning.benefit": benefitWarnings,
      });

      setChangeData(false);

    } catch (error) {
      console.error("保存エラー:", error);
      setUploading(false);
    } finally {
      setUploading(false);
      setBanner(true);
      setTimeout(() => { setBanner(false); }, 1500);
    }
  };

  const generateTimeList = (startHour: number, endHour: number) => {
    const list = ['未選択'];
    for (let h = startHour; h <= endHour; h++) {
      list.push(`${h}:00`);
      if (h !== endHour) list.push(`${h}:30`);
    }
    return list;
  };

  // list1: 6:00〜12:00
  const list1 = generateTimeList(6, 18);

  // list2: 18:00〜24:00
  const list2 = generateTimeList(12, 24);


  const parseTimeToMinutes = (t?: string | null) => {
    if (!t || t === '未選択') return null;
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  };

  const start = parseTimeToMinutes(benefit.workingHours.time1Start);
  const end = parseTimeToMinutes(benefit.workingHours.time1End);

  const isNumeric = (str: string) => !!str && !/^[0-9]+$/.test(str);

  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage.message} />}
    {banner && <div className={Styles.banner}>保存しました。</div>}
    {hintText.title !== "" && ( <Hint contents={hintText} setHintText={setHintText} /> )}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>福利厚生</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <div id="commutingAllowance.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "commutingAllowance.exist"}
        title={'通勤手当の有無'} list={[ '未選択', "実費支給（上限有り）", "実費支給（上限無し）", "一定額", "支給無し" ]}
        value={benefit.commutingAllowance.exist ?? '未選択'}
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, commutingAllowance: { ...prev.commutingAllowance, exist: val === '未選択' ? null : val, } }));
          setChangeData(true);
          setErrorMessage(null);
        }}/>

      <div id="commutingAllowance.text" tabIndex={-1}></div>
      {(benefit.commutingAllowance.exist === "実費支給（上限有り）" || benefit.commutingAllowance.exist === "一定額") && (
      <DefaultInput1
        error={errorMessage?.fieldId === "commutingAllowance.text"}
        title={'通勤手当の金額'} length={25} place={benefit.commutingAllowance.exist === "一定額" ? '電車通勤者は毎月1万円支給' : "最大3万円まで支給"}
        value={benefit.commutingAllowance.text}
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, commutingAllowance: { ...prev.commutingAllowance, text: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }} />
      )}

    </div>

    <div className={Styles.test_box}>

      <div id="overtime.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "overtime.exist"}
        title={'時間外労働の有無'} list={[ '未選択', "時間外労働有り", "時間外労働無し", ]}
        value={ benefit.overtime.exist === null ? '未選択' : benefit.overtime.exist ? '時間外労働有り' : '時間外労働無し' }
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, overtime: { ...prev.overtime, exist: val === '時間外労働有り' ? true : val === '時間外労働無し' ? false : null, }, }));
          setChangeData(true);
          setErrorMessage(null);
        }} />
      <DefaultDesc text={"※警告：法定労働時間外の業務には、原則36協定の締結が必要になります。"} type={"warning"} error={!Boolean(info.exist36Agreement) && Boolean(benefit.overtime.exist)} />

      <div id="overtime.text" tabIndex={-1}></div>
      {benefit.overtime.exist && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "overtime.text"}
          title={'時間外労働の月平均（時間）'} length={2} place={'20'}
          value={benefit.overtime.text}
          setValue={(val: string) => {
            setBenefit(prev => ({ ...prev, overtime: { ...prev.overtime, text: val } }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <div style={{ height : "10px" }}></div>
        <p className={Styles.desc} style={benefit.overtime.text && !(/^\d+$/.test(benefit.overtime.text)) ? { color: "#E31C5F", fontWeight: "bold" } : {}}>※半角数字のみ入力してください。</p>
        <p className={Styles.desc} style={45 < (Number(benefit.overtime.text) + Number(employment20?.fixedOvertime?.time || 0)) ? { color: "#F2941A", fontWeight: "bold" } : {}}>※時間外労働（みなし残業を含む）の月平均時間は45時間が上限となっております。</p>
      </> )}

    </div>

    <div className={Styles.test_box}>

      {/* 就業時間1 */}
      <div id="workingHours.time1Start" tabIndex={-1}></div>
      <div id="workingHours.time1End" tabIndex={-1}></div>
      <DefaultSelect2
        error1={errorMessage?.fieldId === "workingHours.time1Start"}
        error2={errorMessage?.fieldId === "workingHours.time1End"}
        title={'勤務時間 ①'} required={true}
        value1={benefit.workingHours.time1Start}
        setValue1={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time1Start: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list1={list1}
        value2={benefit.workingHours.time1End}
        setValue2={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time1End: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list2={list2} />

      <div id="workingHours.time2Start" tabIndex={-1}></div>
      <div id="workingHours.time2End" tabIndex={-1}></div>
      <div id="workingHours.time2" tabIndex={-1}></div>
      <DefaultSelect2
        error1={errorMessage?.fieldId === "workingHours.time2Start"}
        error2={errorMessage?.fieldId === "workingHours.time2End"}
        title={'勤務時間 ②'} required={true}
        value1={benefit.workingHours.time2Start}
        setValue1={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time2Start: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list1={list1}
        value2={benefit.workingHours.time2End} setValue2={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time2End: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list2={list2} />

      <div id="workingHours.time3Start" tabIndex={-1}></div>
      <div id="workingHours.time3End" tabIndex={-1}></div>
      <div id="workingHours.time3" tabIndex={-1}></div>
      <DefaultSelect2
        error1={errorMessage?.fieldId === "workingHours.time3Start"}
        error2={errorMessage?.fieldId === "workingHours.time3End"}
        title={'勤務時間 ③'} required={true} desc={'※勤務時間③は学校のシステム、及び生徒向けアプリにのみ表示されます。'}
        value1={benefit.workingHours.time3Start}
        setValue1={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time3Start: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list1={list1}
        value2={benefit.workingHours.time3End}
        setValue2={(val: string) => {
          setBenefit(prev => ({ ...prev, workingHours: { ...prev.workingHours, time3End: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list2={list2} />

      <div id="dailyBreak" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "dailyBreak"}
        title={'休憩時間（分）'} length={3} place={'60'}
        value={benefit.dailyBreak || ''}
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, dailyBreak: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      <DefaultDesc text={"※半角数字のみ入力してください。"} type={"error"} error={isNumeric(benefit.dailyBreak)} />
      {(!Boolean(info.exist36Agreement) && start && end && ((end - start) - Number(benefit.dailyBreak)) > 480) && (
        <DefaultDesc text={"※警告：休憩時間は、労働時間が8時間以内（①を基準とする）になるよう設定する必要があります。"} type={"warning"} error={true} />
      )}

    </div>

    <div className={Styles.test_box}>

      <div id="regularHolidays" tabIndex={-1}></div>
      <DefaultCheckBox
        error={errorMessage?.fieldId === "regularHolidays"}
        title={'定休日'} list={[ "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日", "日曜日", "祝日", "不定休" ]}
        value={benefit.regularHolidays}
        setValue={(val: string[]) => {
          setBenefit((prev) => ({ ...prev, regularHolidays: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      <div id="holidayPolicy.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "holidayPolicy.exist"}
        title={'休日制度'}
        list={[ "未選択", "完全週休二日制", "週休二日制", "隔週休二日制", "シフト制", "その他" ]}
        value={benefit.holidayPolicy.exist === null ? '未選択' : benefit.holidayPolicy.exist}
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, holidayPolicy: { ...prev.holidayPolicy, exist: val === '未選択' ? null : val, }, }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "休日制度の一覧", desc: "会社がどのようにこの休日を設定しているかを以下を参考にして、記載してください。<br/><br/><strong>休日制度 例）</strong><br/>・完全週休二日制：毎週2日必ず休みあり（例：土日休みなど）<br/>・週休二日制：月に1回以上、2日休める週がある（毎週ではない）<br/>・隔週休二日制：隔週で2日休み（例：第1・3土曜出勤など）<br/>・週休一日制：毎週1日だけ休みあり（労基法上の最低基準）<br/>・シフト制（交替制休日）：固定曜日でなく、シフトで休日を設定（週1回以上は休日）<br/>・完全週休三日制：毎週3日必ず休みあり（働き方改革で一部企業が導入）<br/>・年間休日制（変形休日制）：年間で休日数を定める制度（例：年間休日120日など）<br/>・定休日＋公休制度：特定の曜日を定休日にし、それ以外に公休日を付与（例：毎週月曜＋月2日公休）"}} setHintText={setHintText} />

      {(benefit.holidayPolicy.exist && benefit.holidayPolicy.exist === "その他") && (
      <>
      <div id="holidayPolicy.text" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "holidayPolicy.text"}
        title={'休日制度'}
        length={15}
        place={''}
        desc={''}
        value={benefit.holidayPolicy?.text || ''}
        setValue={(val: string) => {
          setBenefit(prev => ({ ...prev, holidayPolicy: { ...prev.holidayPolicy, text: val } }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "", desc: ""}} setHintText={setHintText}
      /> </>)}

      <div id="daysOff" tabIndex={-1}></div>
      <DefaultCheckBox
        error={errorMessage?.fieldId === "daysOff"}
        title={'休暇'} list={[ "産前休業", "育児休業", "介護休業", "慶弔休暇", "夏季休暇", "冬期休暇", "年末年始休暇" ]}
        value={benefit.daysOff}
        setValue={(val: string[]) => {
          setBenefit((prev) => ({ ...prev, daysOff: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      <div id="annualHolidays" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "annualHolidays"}
        title={'年間休日数'} length={3} place={'105'}
        value={benefit.annualHolidays}
        setValue={(val: string) => {
          setBenefit((prev) => ({ ...prev, annualHolidays: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />
      <DefaultDesc text={"※半角数字のみ入力してください。"} type={"error"} error={isNumeric(benefit.annualHolidays)} />
      <DefaultDesc text={"※有給休暇（計画的付与分を含む）分の日数を除いて記載してください。"} />

      <div id="paidLeave" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "paidLeave"}
        title={'年次有給休暇数(日)'} length={2} place={'20'} desc={''}
        value={benefit.paidLeave}
        setValue={(val: string) => {
          setBenefit((prev) => ({ ...prev, paidLeave: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "", desc: ""}} setHintText={setHintText} />
      <DefaultDesc text={"※半角数字のみ入力してください。"} type='error' error={isNumeric(benefit.paidLeave)} />
      <DefaultDesc text={"※警告：週5日出勤の場合、年次有給休暇数の下限は10日と定められています。"} type='warning' error={10 > Number(benefit.paidLeave)} />

    </div>

    <div className={Styles.test_box}>

      <div id="insurance" tabIndex={-1}></div>
      <DefaultCheckBox
        error={errorMessage?.fieldId === "insurance"}
        title={'加入保険'} list={[ '雇用保険', '労災保険', '厚生年金', '健康保険' ]} desc={''}
        value={benefit.insurance}
        setValue={(val: string[]) => {
          setBenefit((prev) => ({ ...prev, insurance: val }));
          setChangeData(true)
          setErrorMessage(null);
        }}/>

      <div id="otherText" tabIndex={-1}></div>
      <DefaultTextarea1
        error={errorMessage?.fieldId === "otherText"}
        title={'その他の福利厚生'} length={90} place={''} desc={''}
        value={benefit.otherText} setValue={(val: string) => {setBenefit((prev) => ({ ...prev, otherText: val })); setChangeData(true);}} />

      <div id="tabaco" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "tabaco"}
        title={'受動喫煙対策'} length={20} place={'喫煙所有り、喫煙室の設置済み'} desc={''}
        value={benefit.tabaco}
        setValue={(val: string) => {
          setBenefit((prev) => ({ ...prev, tabaco: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "受動喫煙対策の記載方法", desc: "2020年から受動喫煙対策の記載が義務化されたため、以下の例に沿って記載してください。<br /><br /><strong>受動喫煙対策 例）</strong><br />・屋内全面禁煙<br />・屋内禁煙／屋外に喫煙スペースあり<br />・屋内原則禁煙（喫煙専用室あり）<br />・敷地内禁煙<br />・スタッフ専用スペースのみ喫煙可"}} setHintText={setHintText} />
      <DefaultDesc text={"※勤務場所での喫煙有無、及びその対策についてご入力ください。"} />

    </div>

    </>
  );
}

export default SchoolEmployment;
